import React from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

class InvoiceForAllMembers extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            invoice_date: '',
            error_list: {},
            loader: false,
            overLay: '',
            loader_status: false,
            try_again_status: false,
            main_content_status: false,
        };
    }

    setLoaderFunction = () => {

        this.setState({
            loader_status: true,
            try_again_status: false,
            main_content_status: false,
        });
    };
    closeLoaderFuncion = () => {
        this.setState({
            loader_status: false,
            try_again_status: false,
            main_content_status: true,
        });
    };

    enableTryAgain = () => {

        this.setState({
            loader_status: false,
            try_again_status: true,
            main_content_status: false,
        });
    };

    componentDidMount() {
        this.setLoaderFunction();
        const token = localStorage.getItem("token");
        setTimeout(
            function () {
                this.closeLoaderFuncion();
            }.bind(this),
            500
        );
    }

    tryAgain = () => {
        this.componentDidMount();
    }


    handleInput = (e) => {
        this.setState({
            [e.target.name]: e.target.value,
        });
    };

    saveInvoice = async (e) => {
        this.setLoaderFunction();
        e.preventDefault();

        var token = localStorage.getItem("token");
        const headers = {
            authorization: `Bearer ${token}`,
            Accept: "application/json",
        };

        try {
            const res = await axios.post("/api/invoice/all/members", this.state, {
                headers,
            });

            if (res.data.success) {
                setTimeout(() => {
                    this.closeLoaderFuncion();
                    this.setState({ redirect: true });
                }, 1000);
                toast.success('Invoice generated successfully');
            } else {
                this.closeLoaderFuncion();
                this.setState({ error_list: res.data.data });
            }
        } catch (error) {
            console.error('Error:', error);
            this.closeLoaderFuncion();
        }
    };

    render() {

        return (

            <div className="p-4">
                {/*loader_status------------------------------------------------------------------------*/}
                {this.state.loader_status && (
                    <div className="h-screen flex items-center justify-center bg-white bg-opacity-50 z-50">
                        <div className="bg-white p-4 rounded-md">
                            <div className="flex items-center justify-center">
                                <div
                                    className="animate-spin rounded-full border-4 border-l-blue-500 border-r-blue-500 border-t-blue-500 border-white-300 h-12 w-12"></div>
                            </div>
                            <p className="text-center mt-4">Loading...</p>
                        </div>
                    </div>
                )}
                {/*loader_status------------------------------------------------------------------------*/}

                {/*try_again_status-----------------------------------------------------------------------------*/}
                {this.state.try_again_status && (
                    <div className="h-screen flex items-center justify-center bg-white ">
                        <div className="flex flex-col items-center justify-center h-full">
                            <p className="text-red-500">{this.state.error_customize}</p>
                            <button
                                type="button"
                                onClick={this.tryAgain}
                                className="rounded-md bg-indigo-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">
                                TryAgain
                            </button>
                        </div>
                    </div>
                )}
                {/*try_again_status-----------------------------------------------------------------------------*/}





                {this.state.main_content_status && (
                    <div className="flex flex-col flex-1">
                        <h1 className="text-xl font-semibold text-gray-900">
                            Generate Invoice for All Members
                        </h1>
                        <form onSubmit={this.saveInvoice}>
                            <div className="mt-10 col-span-6 sm:col-span-6 lg:col-span-3 w-1/2">
                                <label htmlFor="invoice_date" className="block text-sm font-medium text-gray-700">
                                    <span className="after:content-['*'] after:ml-0.5 after:text-red-500 block text-sm font-medium text-slate-700">
                                        Select Date
                                    </span>
                                </label>
                                <input
                                    type="date"
                                    name="invoice_date"
                                    id="invoice_date"
                                    onChange={this.handleInput}
                                    autoComplete="given-name"
                                    className="mt-4 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                                />
                                <p className="mt-2 text-sm text-red-600" id="invoice_date-error">
                                    {this.state.error_list.invoice_date}
                                </p>
                            </div>
                            <button type="submit" className="mt-4 inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                                Generate
                            </button>
                        </form>
                    </div>
                )}
            </div>

        );
    }
}

export default InvoiceForAllMembers;
